import { Stack } from "@mui/material";
import React from "react";
import ScrollTracker from "../general-components/ScrollTracker";
import SponsorUsPackages from "../components/sponsor-us/sponsor-us-packages";
import SponsorUsContext from "../components/sponsor-us/sponsor-us-context";

const BecomeOurSponsor = () => {
  return (
    <ScrollTracker
      eventProperties={{
        page: "sponsor_us",
      }}
      threshold={0.5}
    >
      <Stack
        spacing={2}
        sx={{
          padding: 3,
        }}
      >
        <SponsorUsContext />
        <SponsorUsPackages />
      </Stack>
    </ScrollTracker>
  );
};

export default BecomeOurSponsor;
